module.exports = __webpack_public_path__ + "static/metrics-card-1-35aab7f366128b67187088eaa9c2a193.png";